import { Document } from "domain/entities/document";
import { Employee } from "domain/entities/employee";
import { TimesheetReport } from "domain/entities/timesheet-report";
import { EMAIL } from "domain/enum/email";
import { uploadTimesheetPdfBlob } from "presentation/services/documentService";
import { useDocumentByFilter } from "presentation/hooks/use-query-document";
import { DocumentInputFilter } from "domain/models/document-input-filter";
import { useAuthStore } from "presentation/stores/use-auth-store";
import {
  useCreateDocumentMutation,
  useDeleteDocumentMutation,
} from "presentation/hooks/use-query-document";

interface ProcessReportParams {
  /** O blob do PDF já gerado. */
  blob: Blob;
  /** Os dados do relatório para construir o nome do ficheiro e a pasta. */
  report: TimesheetReport;
  /** O empregado associado. */
  employee: Employee;
  /** O ID do tipo de documento. */
  docTypeId: string;
}

/**
 * Função personalizada para gerir o processo de geração, upload e
 * armazenamento de relatórios de timesheet em PDF.
 */
export const useTimesheetUploader = () => {
  const { email: userEmployeeEmail, userEmployee } = useAuthStore();
  const { mutateAsync: createDocumentMutation } = useCreateDocumentMutation();
  const { mutateAsync: deleteDocumentMutation } = useDeleteDocumentMutation();

  /**
   * Faz o upload de um blob de PDF e cria o registo do documento correspondente.
   */
  const processSingleReport = async ({
    blob,
    report,
    employee,
    docTypeId,
  }: ProcessReportParams) => {
    // 1. Fazer upload do PDF
    const filePath = await uploadTimesheetPdfBlob({ blob, report, employee });

    // 2. Criar o registo do documento
    const documentToCreate: Document = {
      id: undefined,
      fullPath: filePath,
      documentType: { id: docTypeId },
      employee: { id: employee.id },
      lastModifiedBy: userEmployeeEmail ?? EMAIL,
    };
    delete (documentToCreate as any).id;
    await createDocumentMutation(documentToCreate);
  };

  return { processSingleReport, deleteDocumentMutation };
};
